import {
  deleteFolderEffect,
  FOLDERS_STALE_TIME_MS,
  type FolderRow,
  foldersQueryKey,
  listFoldersEffect,
} from '../folders';
import { createListEntity } from './optimistic-list-entity';

// Per-entity collection-shaped hooks over the `foldersQueryKey` list cache.
// Shared across apps (start / browser-ext / mobile) — runtime resolved via
// `AppRuntimeProvider`. See docs/projects/complete/web/shared-tanstack-query.md.
//
// Rename (path), create, and move-audio live in per-app folder service files:
// they touch multiple caches (the list AND the per-folder detail cache) and
// own their own snapshots/rollbacks. The single-cache helper can't update the
// detail cache and throws when the row isn't in the list cache (cold on a
// direct /files/$folderId load), so it's unsuitable for rename specifically.
const folderEntity = createListEntity({
  queryKey: foldersQueryKey,
  listEffect: () => listFoldersEffect,
  getId: (f: FolderRow) => f.id,
  staleTime: FOLDERS_STALE_TIME_MS,
  operations: {
    remove: ({ id }) => deleteFolderEffect(id, false),
  },
});

export const useFoldersCollection = folderEntity.useEntity;
// Folder list is read both on the files route and in the move-to-folder
// dropdown (off any route), so it stays non-suspense (≙ `useLiveQuery`).
export const useFoldersListQuery = folderEntity.useListQuery;
